import { Injectable } from '@angular/core';
import { AuthHttp } from 'angular2-jwt';
import { environment } from '../../../../../environments/environment';
import { Observable } from 'rxjs/Observable';
import { IHistItem } from '../models/hist-item';
import { objectToQueryString } from '../../../../shared/functions/commom.functions';
import { IPaginatedResponse } from '../../../../shared/models/pagination';

@Injectable()
export class ReconHistoryService {

  private _apiBaseUrl = environment.apiBaseUrl;

  constructor(private _authHttp: AuthHttp) {
  }

  public getHistoryItems(queryParams = {}): Observable<IPaginatedResponse<IHistItem>> {
  const queryParamsString = objectToQueryString(queryParams);
  return this._authHttp.get(`${this._apiBaseUrl}/recons/recon/${queryParamsString}`)
      .map(res => res.json());
  }

  public deleteHistoryItem(id): Observable<null> {
    return this._authHttp.delete(`${this._apiBaseUrl}/recons/recon/${id}/`)
      .map(res => res.json());
  }

}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/views/daily-recon/recon-history/services/recon-history.service.ts